import type { DialogsCentral } from './types';

export const dialogsInitialState: DialogsCentral = {
  isOpen: false,
};
